window.apiUrl = process.env.REACT_APP_NODE_ENV === 'local' 
? 'http://localhost:80/api'
: 'https://www.votesee.org/api'; 

